import { TmapApp } from '@tmap-web-lib/tmap-app-interface';
import { CSSProperties, useEffect } from 'react';

interface DialogPopupProps {
  onConfirmClick: () => void;
  onCancelClick: () => void;
}
const DialogPopup = ({ onCancelClick, onConfirmClick }: DialogPopupProps) => {
  useEffect(() => {
    TmapApp.handleBackKeyEventFromWeb({ handleFromWeb: true });
    const removeEventListener = TmapApp.utils.addNativeEventListener(
      'onHardwareBackKeyPressed',
      () => {
        onCancelClick();
      }
    );

    return () => {
      TmapApp.handleBackKeyEventFromWeb({ handleFromWeb: false });
      removeEventListener();
    };
  }, [onCancelClick]);

  return (
    <div
      style={style.backdrop}
      onClick={(e) => {
        e.stopPropagation();
        onCancelClick();
      }}
    >
      <div
        style={style.container}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={style.content}>
          <strong style={style.title}>
            서비스 이용을 위해
            <br />
            앱을 업데이트 해주세요.
          </strong>
        </div>
        <div style={style.buttonGroup}>
          <button
            style={style.cancelBtn}
            onClick={onCancelClick}
          >
            닫기
          </button>
          <button
            style={style.confirmBtn}
            onClick={onConfirmClick}
          >
            업데이트하기
          </button>
        </div>
      </div>
    </div>
  );
};

export default DialogPopup;

const style = {
  backdrop: {
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(0, 0, 0, 0.60)',
  } as CSSProperties,
  container: {
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    boxShadow: '0 8px 16px 0 rgba(0, 0, 0, 0.14)',
    width: '312px',
    borderRadius: 8,
  } as CSSProperties,
  content: {
    display: 'flex',
    boxSizing: 'border-box',
    width: '100%',
    padding: '48px 20px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    borderRadius: '8px 8px 0 0',
    backgroundColor: '#FFFFFF',
  } as CSSProperties,
  title: {
    color: '#171819',
    textAlign: 'center',
    fontSize: 18,
    fontWeight: 400,
    lineHeight: '24px',
  } as CSSProperties,
  buttonGroup: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'flex-end',
  } as CSSProperties,
  confirmBtn: {
    height: 52,
    flex: '1 0 0',
    borderRadius: '0 0 8px 0',
    backgroundColor: '#0064FF',
    border: 'none',
    color: '#FFFFFF',
    textAlign: 'center',
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '24px',
  } as CSSProperties,
  cancelBtn: {
    height: 52,
    flex: '1 0 0',
    borderRadius: '0 0 0 8px',
    backgroundColor: '#EEF0F3',
    border: 'none',
    color: '#171819',
    textAlign: 'center',
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '24px',
  } as CSSProperties,
} as const;
